import { z } from 'zod'

export const DoubleDtoSchema = z.number().nonnegative()

export type DoubleDto = z.infer<typeof DoubleDtoSchema>
